var _style, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPinterestWhite = function SvgPinterestWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,2C12.3,2,2,12.3,2,25s10.3,23,23,23s23-10.3,23-23S37.7,2,25,2z M27.5,32.7c-3.3,0-4.5-2.1-4.5-2.1 s-0.6,2.3-1,4s-0.5,1.7-0.9,2.6c-0.5,1-1.6,2.7-2,3.2c-0.3,0.4-0.6,0.7-0.8,0.7c-0.2,0-0.2-0.2-0.2-0.7c-0.1-0.6-0.3-2.6-0.2-3.9 c0.1-0.9,0.4-2.4,0.4-2.4l2.2-9.1c-1.4-2.8-0.2-7.2,2.9-7.2c2.2,0,2.8,2,2.1,4.4c-0.3,1.1-1.2,4.1-1.3,4.2c0,0.1-0.1,0.4-0.1,0.7 c0,0.9,0.7,2.7,3,2.7c3.7,0,5.5-5.5,5.5-9.2c0-3-1.9-6.6-7.4-6.6c-5.6,0-8.7,4.3-8.7,8.2c0,2.2,0.9,3.1,1.3,3.6 c0.3,0.4,0.2,0.8,0.2,0.8l-0.4,1.4c-0.1,0.5-0.6,0.7-1.1,0.4c-0.6-0.3-3.4-1.5-3.4-6.6C13,16.4,17.9,11,25.6,11 C31.6,11,37,14.8,37,21C37,28.6,32.2,32.7,27.5,32.7z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPinterestWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Pinterest_white.d528715f.svg";
export { ForwardRef as ReactComponent };